export const OFFICE_SERVERS__ROOT = '/office_servers';
export const OFFICE_SERVERS__AUDIT_LOGS = '/office_servers/audit_logs';

export const FINALITY_LOGS__ROOT = '/finality_logs';